// src/app/core/guards/cmkt-enabled.match.guard.ts
import { inject } from '@angular/core';
import { CanMatchFn, Router, UrlTree } from '@angular/router';
import { TrunkBaseConfigurationService } from '@core/services/trunk-base-configuration/trunk-base-configuration.service';

export const MKTTrunkbaseGuard: CanMatchFn = (): boolean | UrlTree => {
  const trunkBaseConfigurationService = inject(TrunkBaseConfigurationService);
  const router = inject(Router);

  const isActive = trunkBaseConfigurationService.CMKTModule;

  return isActive ? true : router.createUrlTree(['query-builder']);
};